import { Info } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { useState } from "react";
import { getHelpTopic } from "../../lib/helpContent";

// Small "(i)!" icon that opens a how-to modal for a given help topic. Drop this next to any
// tab/feature that tends to confuse new GMs (map creation, NPC setup, free roam, etc.).
export function InfoTip({ topic, className = "" }) {
  const [open, setOpen] = useState(false);
  const data = getHelpTopic(topic);
  if (!data) return null;

  return (
    <>
      <button
        type="button"
        data-testid={`info-tip-${topic}`}
        onClick={() => setOpen(true)}
        aria-label={`How-to: ${data.title}`}
        className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#D4AF37]/15 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-colors duration-200 shrink-0 ${className}`}
      >
        <Info className="w-3 h-3" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid={`info-tip-modal-${topic}`}>
          <DialogHeader>
            <DialogTitle className="font-display text-xl text-[#f1e0c5]">{data.title}</DialogTitle>
          </DialogHeader>
          {data.image && (
            <img
              src={data.image}
              alt={data.title}
              data-testid={`info-tip-image-${topic}`}
              className="w-full h-36 object-cover rounded-lg border border-white/10"
            />
          )}
          <ul className="space-y-2 text-sm text-[#f1e0c5]/70 list-disc pl-4">
            {data.body.map((line, i) => (
              <li key={i}>{line}</li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>
    </>
  );
}
